import { injectable, injectFromBase } from 'inversify'
import { cloneDeep } from 'lodash-es'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import type {
  SubAccountPermissionsAccount,
  SubAccountPermissionsActions,
  SubAccountPermissionsChannels,
  SubAccountPermissionsContacts,
  SubAccountPermissionsMessaging,
  SubAccountPermissionsReporting,
  SubAccountPermissionsServices,
} from '@/data/models/domain/SubAccountPermissions'
import SubAccountPermissions from '@/data/models/domain/SubAccountPermissions'
import type { ModelRaw } from '@/types'

@RepoSettings<Endpoint>({
  model: SubAccountPermissions,
})
@injectable()
@injectFromBase()
export default class SubAccountPermissionsRepository extends OrmApiRepository<SubAccountPermissions> {
  public async getPermissions(userId: string) {
    const path = this.endpointsService.getPath('subAccountPermissions', [userId])
    const res = await this.getApiSource().get<Record<string, any>>(path)
    await this.insertOrUpdate([{ ...res.data, id: userId }])
    return this.findEntityByIdOrFail(userId)
  }

  public async updatePermissions(userId: string, settings: UpdatePermissionsRequestBody) {
    const path = this.endpointsService.getPath('subAccountPermissions', [userId])
    // @todo convert boolean to int, delete after fix api method
    const mapSettings: any = cloneDeep(settings)
    for (const mapSettingsKey in mapSettings) {
      Object.keys(mapSettings[mapSettingsKey]).forEach((t) => {
        mapSettings[mapSettingsKey][t] = +mapSettings[mapSettingsKey][t]
      })
    }
    // -------
    await this.getApiSource().put(path, mapSettings)
    return this.getPermissions(userId)
  }

  public updatePermissionsInStore(userId: string, permissions: ModelRaw<SubAccountPermissions>) {
    return this.insertOrUpdate([{ ...permissions, id: userId }])
  }
}

export interface UpdatePermissionsRequestBody {
  actionsPermissions?: Partial<SubAccountPermissionsActions>

  messagingPermissions?: Partial<SubAccountPermissionsMessaging>

  channelsPermissions?: Partial<SubAccountPermissionsChannels>

  contactsPermissions?: Partial<SubAccountPermissionsContacts>

  servicesPermissions?: Partial<SubAccountPermissionsServices>

  accountPermissions?: Partial<SubAccountPermissionsAccount>

  reportingPermissions?: Partial<SubAccountPermissionsReporting>
}
